/*@ngInject*/
const PolicyRewriteActionsMediator = function (policyRewriteActionRepository) {

    this.getPolicyRewriteSummary = function (policyRewriteId) {
        return policyRewriteActionRepository.getPolicyRewriteSummary(policyRewriteId);
    };

    this.delete = function (policyRewriteId) {
        return policyRewriteActionRepository.deletePolicyRewrite(policyRewriteId);
    };

    this.create = function (policyRewriteId) {
        return policyRewriteActionRepository.create(policyRewriteId);
    };

    this.submit = function (policyRewriteId) {
        return policyRewriteActionRepository.submit(policyRewriteId);
    };

    this.startRating = function (policyRewriteId) {
        return policyRewriteActionRepository.startRating(policyRewriteId);
    };

    this.refreshQuote = function (policyRewriteId) {
        return policyRewriteActionRepository.refreshQuote(policyRewriteId);
    };

    this.submitForIssuance = function (policyRewriteId) {
        return policyRewriteActionRepository.submitForIssuance(policyRewriteId);
    };

    this.markIssued = function (policyRewriteId) {
        return policyRewriteActionRepository.markIssued(policyRewriteId);
    };

    this.revertToSubmitted = function (policyRewriteId) {
        return policyRewriteActionRepository.revertToSubmitted(policyRewriteId);
    };

    this.generateRating = function (policyRewriteId) {
        return policyRewriteActionRepository.generateRating(policyRewriteId);
    };

    this.generateRatingAttachments = function (policyRewriteId, attachmentsToGenerate) {
        return policyRewriteActionRepository.generateRatingAttachments(policyRewriteId, attachmentsToGenerate);
    }

    this.startPricing = function (policyRewriteId) {
        return policyRewriteActionRepository.startPricing(policyRewriteId);
    };

    this.modifyPricing = function (policyRewriteId) {
        return policyRewriteActionRepository.modifyPricing(policyRewriteId);
    };

    this.modifyRating = function (policyRewriteId) {
        return policyRewriteActionRepository.modifyRating(policyRewriteId);
    };
};

angular.module('gw-um-submission')
    .service('policyRewriteActionsMediator', PolicyRewriteActionsMediator);
